/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    SubscriptionPriceOption,
    UpdateBillingAccountStatusRequest,
    UserBillingAccountDto,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    SubscriptionPriceOptionFromJSON,
    SubscriptionPriceOptionToJSON,
    UpdateBillingAccountStatusRequestFromJSON,
    UpdateBillingAccountStatusRequestToJSON,
    UserBillingAccountDtoFromJSON,
    UserBillingAccountDtoToJSON,
} from "../models/index";

export interface DeleteBillingAccountRequest {
    billingAccountId: number;
}

export interface GetBillingAccountsRequest {
    userAccountId: string;
}

export interface RetryPendingBillingPaymentRequest {
    transactionId: number;
}

export interface UpdateBillingAccountStatusOperationRequest {
    userBillingAccountId: string;
    body?: UpdateBillingAccountStatusRequest;
}

/**
 *
 */
export class UserBillingHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Delete the billing account of a user.
     */
    async deleteBillingAccountRaw(
        requestParameters: DeleteBillingAccountRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["billingAccountId"] == null) {
            throw new runtime.RequiredError(
                "billingAccountId",
                'Required parameter "billingAccountId" was null or undefined when calling deleteBillingAccount().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/billing-accounts/{billingAccountId}`.replace(
                    `{${"billingAccountId"}}`,
                    encodeURIComponent(
                        String(requestParameters["billingAccountId"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete the billing account of a user.
     */
    async deleteBillingAccount(
        requestParameters: DeleteBillingAccountRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deleteBillingAccountRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get all available subscription prices from Stripe
     */
    async getAvailableSubscriptionPricesRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<SubscriptionPriceOption>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/billing-subscription-prices`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(SubscriptionPriceOptionFromJSON),
        );
    }

    /**
     * Get all available subscription prices from Stripe
     */
    async getAvailableSubscriptionPrices(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<SubscriptionPriceOption>> {
        const response =
            await this.getAvailableSubscriptionPricesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all billing account for a user.
     */
    async getBillingAccountsRaw(
        requestParameters: GetBillingAccountsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<UserBillingAccountDto>>> {
        if (requestParameters["userAccountId"] == null) {
            throw new runtime.RequiredError(
                "userAccountId",
                'Required parameter "userAccountId" was null or undefined when calling getBillingAccounts().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/billing-accounts/{userAccountId}`.replace(
                    `{${"userAccountId"}}`,
                    encodeURIComponent(
                        String(requestParameters["userAccountId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(UserBillingAccountDtoFromJSON),
        );
    }

    /**
     * Get all billing account for a user.
     */
    async getBillingAccounts(
        requestParameters: GetBillingAccountsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<UserBillingAccountDto>> {
        const response = await this.getBillingAccountsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Re-trigger payment for a Shared/Private Billing transaction with status Pending.
     */
    async retryPendingBillingPaymentRaw(
        requestParameters: RetryPendingBillingPaymentRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["transactionId"] == null) {
            throw new runtime.RequiredError(
                "transactionId",
                'Required parameter "transactionId" was null or undefined when calling retryPendingBillingPayment().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/transactions/{transactionId}/retry-payment`.replace(
                    `{${"transactionId"}}`,
                    encodeURIComponent(
                        String(requestParameters["transactionId"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Re-trigger payment for a Shared/Private Billing transaction with status Pending.
     */
    async retryPendingBillingPayment(
        requestParameters: RetryPendingBillingPaymentRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.retryPendingBillingPaymentRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update the status of a billing account.
     */
    async updateBillingAccountStatusRaw(
        requestParameters: UpdateBillingAccountStatusOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["userBillingAccountId"] == null) {
            throw new runtime.RequiredError(
                "userBillingAccountId",
                'Required parameter "userBillingAccountId" was null or undefined when calling updateBillingAccountStatus().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/billing-accounts/{userBillingAccountId}/status`.replace(
                    `{${"userBillingAccountId"}}`,
                    encodeURIComponent(
                        String(requestParameters["userBillingAccountId"]),
                    ),
                ),
                method: "PATCH",
                headers: headerParameters,
                query: queryParameters,
                body: UpdateBillingAccountStatusRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update the status of a billing account.
     */
    async updateBillingAccountStatus(
        requestParameters: UpdateBillingAccountStatusOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.updateBillingAccountStatusRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
